import React, { type RefObject } from 'react';
import Image from '../../../../../../../shared/components/Image';
import type { CampaignInfoDisplayStyles } from '../../css/base/CampaignInfoDisplayStyles';
import { useCampaignCardScale, useIsHeaderCollapsed } from 'features/campaigns';

interface CampaignInfoLabelProps {
  iconSrc: string;
  label: string;
  colon: string;
  styles: CampaignInfoDisplayStyles;
  attributes: {
    'data-collapsed': string
    'data-view': 'multi' | 'single'
  };
}

const CampaignInfoLabel: React.FC<CampaignInfoLabelProps> = ({ iconSrc, label, colon, styles, attributes }) => {
  const isCollapsed = useIsHeaderCollapsed();
  const { titleRef, scale } = useCampaignCardScale(label + colon, {
    recalculateKey: isCollapsed,
  });

  return (
    <div
      ref={titleRef as RefObject<HTMLDivElement>}
      className={styles.imageLabelWrapper}
      style={{
        transform: scale < 1 ? `scale(${scale})` : undefined,
      }}
      {...attributes}
    >
      <Image src={iconSrc} manualAffix=".svg" />
      <span className={styles.labelText}>{label + colon}</span>
    </div>
  );
};

export default CampaignInfoLabel;
